module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/performers/performers-index/performers-index.component.scss
// module id = ./src/app/routes/performers/performers-index/performers-index.component.scss
// module chunks = 9